/**
 * Application Constants
 * Extracted from the original cart library
 */

export const CART_CONSTANTS = {
  CATEGORIES: {
    NVIDIA: 'nvidia' as const,
    PARTNER: 'partner' as const,
  },
  
  DEFAULT_LOCALE: 'en-US',
  DEFAULT_CURRENCY: 'USD',
  
  STORAGE_KEYS: {
    CART_STATE: 'nvCartState',
    USER_SESSION: 'nvUserSession',
  },
  
  API_ENDPOINTS: {
    CHECKOUT: '/checkout',
    NETWORKING: '/networking',
    CART: '/cart',
  },
} as const;

export const TRANSLATIONS: Record<string, Record<string, string>> = {
  'en-US': {
    addToCart: 'Add to Cart',
    viewCart: 'View Cart',
    checkout: 'Checkout',
    emptyCart: 'Your cart is empty',
    outOfStock: 'Out of Stock',
    inStock: 'In Stock',
  },
  'es-ES': {
    addToCart: 'Agregar al carrito',
    viewCart: 'Ver carrito',
    checkout: 'Pagar',
    emptyCart: 'Tu carrito está vacío',
    outOfStock: 'Agotado',
    inStock: 'En stock',
  },
  // Add more locales as needed
};

export const CSS_CLASSES = {
  CART_CONTAINER: 'cart-main-section',
  CART_WHITE: 'cart_white',
  CART_SECTION: 'cart-section',
  CART_CLOSE: 'cart__close',
  CART_EMPTY: 'cart__empty',
  CART_ITEMS: 'cart__items',
  CHECKOUT_BUTTON: 'js-checkout',
  ADD_BUTTON: 'js-add-button',
  OUT_OF_STOCK: 'js-out-of-stock',
  IN_STOCK: 'js-in-stock',
} as const;

